<ng-container *ngIf="!loading; else loadingBlock">
  <ng-content></ng-content>
</ng-container>

<ng-template #loadingBlock>
  <app-skeleton-loader variant="line" width="18px" height="1em"></app-skeleton-loader>
</ng-template>
